import { If } from "./IfThenElse";

export const IfContainer = If;
